// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { BestFitPharmacyResultSearchBase } from './bestFitPharmacyResultSearchBase.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class BestFitPharmacyResultSearchResponse {
    'results'?: Array<BestFitPharmacyResultSearchBase>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof BestFitPharmacyResultSearchResponse>> = [
        {
            "name":     "results",
            "baseName": "results",
            "type":     "Array<BestFitPharmacyResultSearchBase>"
        },
    ];

    static getAttributeTypeMap() {
        return BestFitPharmacyResultSearchResponse.attributeTypeMap;
    }
}
